/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McAnswerTranslationParam from './McAnswerTranslationParam';

/**
 * The McAnswerParam model module.
 * @module model/McAnswerParam
 * @version 1.0
 */
class McAnswerParam {
    /**
     * Constructs a new <code>McAnswerParam</code>.
     * @alias module:model/McAnswerParam
     */
    constructor() { 
        
        McAnswerParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McAnswerParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McAnswerParam} obj Optional instance to populate.
     * @return {module:model/McAnswerParam} The populated <code>McAnswerParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McAnswerParam();

            if (data.hasOwnProperty('answer')) {
                obj['answer'] = ApiClient.convertToType(data['answer'], 'String');
            }
            if (data.hasOwnProperty('isCorrect')) {
                obj['isCorrect'] = ApiClient.convertToType(data['isCorrect'], 'Boolean');
            }
            if (data.hasOwnProperty('translation')) {
                obj['translation'] = ApiClient.convertToType(data['translation'], {'String': McAnswerTranslationParam});
            }
        }
        return obj;
    }


}

/**
 * @member {String} answer
 */
McAnswerParam.prototype['answer'] = undefined;

/**
 * @member {Boolean} isCorrect
 */
McAnswerParam.prototype['isCorrect'] = undefined;

/**
 * @member {Object.<String, module:model/McAnswerTranslationParam>} translation
 */
McAnswerParam.prototype['translation'] = undefined;






export default McAnswerParam;

